import { useDispatch } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
import { clearUser, setUsers } from "@/store/userSlice";
import { clearSystemService, setRoles } from "@/store/systemServiceSlice";
import { useGetAllUsers } from "@/hooks/user/useGetAllUsers";
import { clearEntity, setCities, setOffices, setUserEntity } from "@/store/entitySlice";
import { useGetAllCities } from "@/hooks/city/useGetAllCities";
import { useGetAllOffices } from "@/hooks/office/useGetAllOffices";
import { useGetRoles } from "@/hooks/systemService/useGetRoles";
import { setProjects } from "@/store/projectsSlice";
import { useGetAllProjects } from "@/hooks/project/useGetAllProject";
import { useGetCity } from "@/hooks/city/useGetCity";

export const useFetchAllEntities = () => {
    const dispatch = useDispatch();

    const getAllCities = useGetAllCities({
        onSuccess(data) {
            dispatch(setCities(data))
        },
        onError(error) {
            console.error(`Error fetching cities`)
        },
    })

    const getAllOffices = useGetAllOffices({
        onSuccess(data) {
            dispatch(setOffices(data))
        },
        onError(error) {
            console.error(`Error fetching offices`)
        },
    })

    return { getAllCities, getAllOffices };
}

export const useFetchAllProjects = () => {
    const dispatch = useDispatch();

    const getAllProjects = useGetAllProjects({
        onSuccess(data) {
            dispatch(setProjects(data))
        },
        onError(error) {
            console.error(`Error fetching projects`)
        },
    })

    return getAllProjects;
}

export const useFetchAllUsers = () => {
    const dispatch = useDispatch();

    const getAllUsers = useGetAllUsers({
        onSuccess(data) {
            dispatch(setUsers(data))
        },
        onError(error) {
            console.error(`Error fetching users`)
        },
    })

    return getAllUsers;
}

export const useFetchRoles = () => {
    const dispatch = useDispatch();

    const getAllRoles = useGetRoles({
        onSuccess(data) {
            dispatch(setRoles(data))
        },
        onError(error) {
            console.error(`Error fetching project roles`)
        },
    })

    return getAllRoles;
}

export const useFetchCity = () => {
    const dispatch = useDispatch();

    const getCity = useGetCity({
        onSuccess(data) {
            dispatch(setUserEntity({
                entityType: "city",
                userCity: data
            }))
        },
    })

    return getCity;
}

export const clearAll = (dispatch: Dispatch) => {
    dispatch(clearEntity());
    dispatch(clearUser());
    dispatch(clearSystemService());
}